import { Navigate } from "react-router-dom";

import Dashboard from "views/Dashboard.js";
import Supplier from "views/Supplier/Supplier";
import SupplierDetail from "views/SupplierDetail/SupplierDetail";
import CustomRequest from "views/CustomRequest";
import HelpSupport from "views/HelpSupport/HelpSupport";
import Profile from "views/Profile/Profile";

import NewRequestView from "views/NewCustomRequestView/NewCustomRequestView";

import UserManagementView from "views/Admin/UserManagementView/UserManagementView";

import SignIn from "views/SignIn";
import Register from "views/Public/Register";

import AdminDashboard from "views/Admin/AdminDashboard";
import AdminAddNewUser from "views/Admin/AdminAddNewUser/AdminAddNewUser";

import sidebar_dashboard_icon from "assets/images/icons/sidebar/sidebar_dashboard_icon.png";
import sidebar_supplier_icon from "assets/images/icons/sidebar/sidebar_supplier_icon.png";
import sidebar_customer_request_icon from "assets/images/icons/sidebar/sidebar_customer_request_icon.png";
import CustomRequestDetail from "views/CustomRequestDetail";

import sidebar_user_management_icon from "assets/images/icons/sidebar/sidebar_user_management_icon.png";

import UserDetails from "views/Admin/UserDetails/UserDetails";
import Onboarding from "views/Public/Onboarding";
import OnboardingPassword from "views/Public/OnboardingPassword/OnboardingPassword";
import ForgerPasswordView from "views/Public/ForgerPasswordView/ForgerPasswordView";
import KnowledgeBaseSupport from "views/KnowledgeBaseSupport";

const ERROR_PAGE = {
  path: "*",
  name: "Not Found",
  //   component: <NotFound />,
  component: <Navigate to="/error" replace />,
  layout: "/public",
  disable_sidebar: true,
};

const routes = {
  public: [
    {
      path: "login/",
      name: "Sign In",
      icon: "nc-icon nc-bank",
      component: <SignIn />,

      layout: "/",
      disable_sidebar: true,
    },
    {
      path: "knowledge-base-and-support/",
      name: "Sign In",
      icon: "nc-icon nc-bank",
      component: <KnowledgeBaseSupport />,

      layout: "/",
      disable_sidebar: true,
    },
    {
      path: "verify_token_onboarding/:token",
      name: "Onboarding",
      icon: "nc-icon nc-bank",
      component: <Onboarding />,
      layout: "/",
      disable_sidebar: true,
    },
    {
      path: "verify_token_onboarding/set_pass/:token",
      name: "Onboarding",
      icon: "nc-icon nc-bank",
      component: <OnboardingPassword />,
      layout: "/",
      disable_sidebar: true,
    },

    {
      path: "forget_password",
      name: "Forget Password",
      icon: "nc-icon nc-bank",
      component: <ForgerPasswordView />,
      layout: "/",
      disable_sidebar: true,
    },

    {
      path: "/*",
      name: "Sign In",
      icon: "nc-icon nc-bank",
      component: <Navigate to="/login" replace />,
      layout: "/",
      disable_sidebar: true,
    },
  ],
  admin: [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: "nc-icon nc-chart-pie-36",
      component: <AdminDashboard />,
      layout: "/admin",
      icon_element: (
        <img
          src={sidebar_dashboard_icon}
          className="h-6 w-6"
          alt="dashboard icon"
        />
      ),
    },
    {
      path: "/user_management",
      name: "User Management",
      icon: "nc-icon nc-chart-pie-36",
      component: <UserManagementView />,
      layout: "/admin",
      icon_element: (
        <img
          src={sidebar_user_management_icon}
          className="h-6 w-6"
          alt="user management icon"
        />
      ),
    },
    {
      path: "/user_management/add_new_user",
      name: "Add New User",
      icon: "nc-icon nc-chart-pie-36",
      component: <AdminAddNewUser />,
      layout: "/admin",
      disable_sidebar: true,
      icon_element: (
        <img
          src={sidebar_user_management_icon}
          className="h-6 w-6"
          alt="user management icon"
        />
      ),
    },
    {
      path: "/user_management/user_details/:user_id",
      name: "User's Associated Supplier",
      icon: <UserManagementView />,
      component: <UserDetails />,
      layout: "/admin",
      disable_sidebar: true,
      icon_element: (
        <img
          src={sidebar_user_management_icon}
          className="h-6 w-6"
          alt="user management icon"
        />
      ),
    },

    ERROR_PAGE,
  ],

  user: [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: "nc-icon nc-chart-pie-36",
      component: <Dashboard />,
      layout: "/user",
      icon_element: (
        <img
          src={sidebar_dashboard_icon}
          className="h-6 w-6"
          img="dashboard icon"
        />
      ),
    },
    {
      path: "/suppliers",
      name: "Suppliers",
      icon: "nc-icon nc-calendar-60",
      component: <Supplier />,
      layout: "/user",
      icon_element: (
        <img
          src={sidebar_supplier_icon}
          className="h-6 w-6"
          alt="supplier icon"
        />
      ),
    },
    {
      path: "/suppliers/:supplier_id",
      name: "Suppliers",
      icon: "nc-icon nc-calendar-60",
      component: <SupplierDetail />,
      layout: "/user",
      disable_sidebar: true,
      icon_element: (
        <img
          src={sidebar_supplier_icon}
          className="h-6 w-6"
          alt="supplier icon"
        />
      ),
    },

    // {
    //   path: "/custom_requests",
    //   name: "Custom Request",
    //   icon: "nc-icon nc-time-alarm",
    //   component: <CustomRequest />,
    //   layout: "/user",

    //   icon_element: (
    //     <img
    //       src={sidebar_customer_request_icon}
    //       className="h-6 w-6"
    //       img="Custom Request icon"
    //     />
    //   ),
    // },
    {
      disable_sidebar: true,
      path: "/custom_requests/new_request",
      name: "Custom Request",
      icon: "nc-icon nc-time-alarm",
      component: <NewRequestView />,
      layout: "/user",

      icon_element: (
        <img
          src={sidebar_customer_request_icon}
          className="h-6 w-6"
          img="Custom Request icon"
        />
      ),
    },
    {
      disable_sidebar: true,
      path: "/custom_requests/:request_id/:supplier_name/",
      name: "Custom Request",
      icon: "nc-icon nc-time-alarm",
      component: <CustomRequestDetail />,
      layout: "/user",

      icon_element: (
        <img
          src={sidebar_customer_request_icon}
          className="h-6 w-6"
          img="Custom Request icon"
        />
      ),
    },
    {
      disable_sidebar: true,
      path: "/help_and_support",
      name: "Help & Support",
      icon: "",
      component: <HelpSupport />,
      layout: "/user",
    },

    {
      disable_sidebar: true,
      path: "/profile",
      name: "My Profile",
      icon: "",
      component: <Profile />,
      layout: "/user",
    },

    ERROR_PAGE,
  ],
};

export default routes;
